import React from "react";
import Header from "./Header";

const HeaderConnected = ({ roteiro }) => {
  return <Header roteiro={roteiro} />;
};

export default HeaderConnected;
